import { action, observable } from 'mobx';

export enum BlanketBody {
  Products = 'products',
  None = 'none',
}

export default class BlanketStore {
  @observable body: BlanketBody = BlanketBody.None;

  @action
  hideBlanket() {
    this.body = BlanketBody.None;
  }

  @action
  showBlanket(body: BlanketBody) {
    this.body = body;
  }
}
